module.exports = __webpack_public_path__ + "img/oufu_70x90x12b.prt.8c6ed6ba.jpg";